import { h } from "vue";
import { priceFormat } from "./qFormat.js";

//关键字高亮
export const tab_Highlinght = (text, key) => {
  if (text != null && text != undefined) {
    let reg = new RegExp("(" + key + ")", "g");
    let newStr = text
      .toString()
      .replace(reg, "<font style='color:#f00'>$1</font>");
    return h("text", { innerHTML: newStr });
  }
};

export const tab_HighlinghtHtml = (text, key) => {
  if (text != null && text != undefined) {
    let reg = new RegExp("(" + key + ")", "g");
    let newStr = text
      .toString()
      .replace(reg, "<font style='color:#f00'>$1</font>");
    return newStr;
  }
};

//内容格式化，如果为空则显示"-"
export const tab_TextFormat = (row, column, cellValue) => {
  return cellValue || "-";
};

//金额格式化
export const tab_NumberFormat = (row, column, cellValue) => {
  if (cellValue == null || cellValue == undefined) return "-";
  return h("text", {}, priceFormat(cellValue, 0));
};

//金额格式化
export const tab_PriceFormat = (row, column, cellValue) => {
  if (cellValue == null || cellValue == undefined) return "-";
  return h("text", {}, priceFormat(cellValue));
};

//金额格式化
export const tab_MoneyFormat = (row, column, cellValue) => {
  if (cellValue == null || cellValue == undefined) return "-";

  const resArr = priceFormat(cellValue || 0).split(".");
  let str = `<text style='font-size:70%'>￥</text><text>${resArr[0]}</text><text style='font-size:80%'>.${resArr[1]}</text>`;
  return h("div", {
    style: "font-weight:600;color:#f00",
    innerHTML: str,
  });
  // return h(
  //   "text",
  //   { style: "color:#f00;font-weight:600" },
  //   "￥" + priceFormat(cellValue || 0)
  // );
};

//组合内容格式化
export const tab_GroupFormat2 = (
  value1,
  value2,
  color1 = "#000",
  color2 = "#a2a2a2"
) => {
  let str =
    "<text style='color:" +
    color1 +
    ";white-space: nowrap;'>" +
    value1 +
    "</text><br /><text style='color:" +
    color2 +
    ";font-size:var(--tab-group-second-font-size);white-space: nowrap;'>" +
    value2 +
    "</text>";

  return h("div", {
    innerHTML: str,
    style: "overflow:hidden;line-height: 18px;",
  });
};

//组合内容格式化(只显示两行，显示不下用省略号代替)
export const tab_GroupFormat = (value1, value2, color1, color2) => {
  return h("div", {
    innerHTML: tab_BuildGroup(value1, value2, color1, color2),
    style: "overflow:hidden",
  });
};

export const tab_BuildGroup = (
  value1,
  value2,
  color1 = "#000",
  color2 = "#a2a2a2"
) => {
  let str =
    "<li title='" +
    value1 +
    "' style='width:100%;color:" +
    color1 +
    ";overflow: hidden;white-space: nowrap;text-overflow: ellipsis;'>" +
    value1 +
    "</li><li title='" +
    value2 +
    "' style='width:100%;color:" +
    color2 +
    ";font-size:var(--tab-group-second-font-size);overflow: hidden;white-space: nowrap;text-overflow: ellipsis;'>" +
    value2 +
    "</li>";

  return str;
};

//内容超过指定行数显示省略号  默认2行
export const tab_ShowToolTip = (row, column, cellValue) => {
  return h("div", {
    innerHTML: cellValue || "-",
    style:
      "display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;",
    title: cellValue,
  });
};
